import React, { useState, useEffect } from "react";
import "../css/ImportContractNote.css";

const Charges = ({ initialCharges, onChargesUpdate }) => {
    // State for editable charge fields
    const [netAmount, setNetAmount] = useState(0);
    const [editableCharges, setEditableCharges] = useState({ ...initialCharges });

    // Update local state when `initialCharges` change, but only if different
    useEffect(() => {
        if (JSON.stringify(editableCharges) !== JSON.stringify(initialCharges)) {
            setEditableCharges({ ...initialCharges });
        }
    }, [initialCharges]);

    // Compute totals when charges change
    useEffect(() => {
        const newNetAmount =
            (editableCharges.payInPayOutObligationNetTotal || 0) +
            (editableCharges.securitiesTransactionTaxNetTotal || 0) +
            (editableCharges.stampDutyNetTotal || 0) +
            (editableCharges.gstTotal || 0) +
            (editableCharges.otherCharges || 0);

        setNetAmount(newNetAmount);

        // Pass updated charges to parent
        onChargesUpdate({
            ...editableCharges,
            netAmountNetTotal: newNetAmount
        });

    }, [editableCharges]);

    // Handle input changes
    const handleChange = (event, field) => {
        const updatedValue = parseFloat(event.target.value) || 0;
        setEditableCharges(prev => ({
            ...prev,
            [field]: updatedValue
        }));
    };

    return (
        <div className="charges-container">
            <h5>Charges</h5>
            {/* First Row */}
            <div className="charges-row">
                <label className="charge-label">Pay in/Pay out:</label>
                <input
                    name="net-payinout-obli"
                    type="number"
                    className="charge-input"
                    value={editableCharges.payInPayOutObligationNetTotal.toFixed(2)}
                    onChange={(e) => handleChange(e, "payInPayOutObligationNetTotal")}
                />

                <label className="charge-label">STT:</label>
                <input
                    name="stt"
                    type="number"
                    className="charge-input"
                    value={editableCharges.securitiesTransactionTaxNetTotal.toFixed(2)}
                    onChange={(e) => handleChange(e, "securitiesTransactionTaxNetTotal")}
                />

                <label className="charge-label">GST (Total):</label>
                <input
                    name="gst"
                    type="number"
                    className="charge-input"
                    value={editableCharges.gstTotal.toFixed(2)} // ✅ Updates dynamically
                    disabled
                />
            </div>

            {/* Second Row */}
            <div className="charges-row">
                <label className="charge-label">Stamp Duty:</label>
                <input
                    name="stamp"
                    type="number"
                    className="charge-input"
                    value={editableCharges.stampDutyNetTotal.toFixed(2)}
                    onChange={(e) => handleChange(e, "stampDutyNetTotal")}
                />

                <label className="charge-label">Other Charges:</label>
                <input
                    name="other"
                    type="number"
                    className="charge-input"
                    value={editableCharges.otherCharges.toFixed(2)} // ✅ Updates dynamically
                    disabled
                />

                <label className="charge-label">Net Amount:</label>
                <input
                    type="number"
                    className="charge-input"
                    value={netAmount.toFixed(2)} // ✅ Updates dynamically
                    disabled
                />
            </div>
            {/* 🔹 Add a hidden input field for `netAmountNetTotal` */}
            <input type="hidden" name="netamount" value={netAmount} />
        </div>
    );
};

export default Charges;
